export default "__VITE_ASSET__DAHwzC2c__"